module.exports = __webpack_public_path__ + "img/close-icon.12ad606d.svg";